import { EmptyResult } from "@themuse/design-system";
import styles from "./Empty.module.scss";

interface IEmptyParams {
    requested: boolean;
    results: number;
    cb: () => void
}

/**
 * Uhho screen renders when there are zero results
 */
const Empty = (params: IEmptyParams) => {
    const { requested, results, cb } = params;
    return requested && !results
        ? (
            <div className={styles.empty}>
                <EmptyResult
                    title="Uh-oh."
                    details="We couldn’t find any jobs that match your search. Please try clearing all your
                            filters, entering a new keyword, or searching in a different location."
                    buttonCta="Clear my Search"
                    onClick={cb}
                />
            </div>
        )
        : null;
};

Empty.displayName = "Empty";
export { Empty };
